var collapsible_list_component_rtlignore_default = {
  "ltr": "e35S-",
  "rtl": "XYYqZ",
  "iconContainer": "lZBgD",
  "icon": "PSmdP",
  "isExpanded": "_6-OMr",
  "listDimensions": "au0qn"
};
export {
  collapsible_list_component_rtlignore_default as default
};
//# sourceMappingURL=collapsible-list-component.rtlignore-scss.js.map
